import { createReducer, on } from '@ngrx/store';
import { Customer, CustomerSummary } from '../../../models/consumer';
import { cleanAccountSummary, loadCustomer, loadCustomerFinished, loadCustomerSummary, loadCustomerSummaryFinished } from './../customer-summary/customer-summary.actions';
import { ContactResponse } from '../../../admin/interfaces/find-email.interface';
import { assignOrRevokePermission, cleanAccountContact, loadCustomerContactsFinished, loadLiveLink, loadLiveLinkFinished } from './customer.actions';
import { UserAccountFeature } from '../../../enums/user-account-feature.enum';

export const customerFeatureKey = 'customer';

export interface CustomerState {
    information: Customer;
    customerSummary: CustomerSummary;
    contacts: ContactResponse[] | null;
    liveLinkLoading: boolean;
    livelinkUrl: string | undefined;
    livelinkExpiry: string | undefined;
}

export const initialState: CustomerState = {
    information: {},
    customerSummary: {},
    contacts: null,
    liveLinkLoading: false,
    livelinkUrl: undefined,
    livelinkExpiry: undefined
};

export const customerSummaryReducer = createReducer(
    initialState,
    on(loadCustomer, (state: CustomerState, { customer }: { customer?: Customer }) => {
        return customer?.Id ? { ...state, information: { ...customer } } : state;
    }),
    on(loadCustomerFinished, (state: CustomerState, { customer }: { customer?: Customer }) => {
        return customer?.Id ? { ...state, information: { ...customer } } : state;
    }),
    on(loadCustomerSummary, (state: CustomerState, { summary }: { summary?: CustomerSummary }) => {
        return summary ? { ...state, customerSummary: { ...summary } } : state;
    }),
    on(loadCustomerSummaryFinished, (state: CustomerState, { summary }: { summary?: CustomerSummary }) => {
        return summary ? { ...state, customerSummary: { ...summary } } : state;
    }),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    on(cleanAccountSummary, (state: CustomerState) => {
        return initialState;
    }),
    on(loadCustomerContactsFinished, (state: CustomerState, { contacts }) => {
        return {
            ...state,
            contacts
        };
    }),
    on(cleanAccountContact, (state: CustomerState) => {
        return {
            ...state,
            contacts: null
        };
    }),
    on(assignOrRevokePermission, (state: CustomerState, { data }) => {
        if (!state.contacts) {
            return state;
        }
        const nonOperatorRoles: UserAccountFeature[] = (Object.values(UserAccountFeature) as UserAccountFeature[]).filter(role => role !== UserAccountFeature.Operator);

        const updatedContacts = state.contacts.map(contact => {
            if (contact.email?.toLowerCase() === data.email.toLowerCase()) {
                const updatedRoles = { ...contact.roles };
                updatedRoles[data.role] = data.enabled;
                const isOperator = data.role === UserAccountFeature.Operator;
                if (data.enabled) {
                    if (isOperator) {
                        nonOperatorRoles.forEach(r => (updatedRoles[r] = false));
                    } else {
                        updatedRoles[UserAccountFeature.Operator] = false;
                    }
                }

                return { ...contact, roles: updatedRoles };
            }
            return { ...contact };
        });
        return {
            ...state,
            contacts: updatedContacts
        };
    }),
    on(loadLiveLink, (state: CustomerState) => {
        return {
            ...state,
            liveLinkLoading: true
        };
    }),
    on(loadLiveLinkFinished, (state: CustomerState, { livelinkUrl, livelinkExpiry }) => {
        return {
            ...state,
            liveLinkLoading: false,
            livelinkUrl,
            livelinkExpiry
        };
    })
);
